import { useState } from 'react';

export interface LoginCardProps {
  readonly onSubmit: (apiKey: string) => Promise<void>;
}

export function LoginCard({ onSubmit }: LoginCardProps) {
  const [apiKey, setApiKey] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await onSubmit(apiKey.trim());
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="card" style={{ maxWidth: 480, margin: '40px auto' }}>
      <h1>Crypto-pay Admin</h1>
      <p className="muted" style={{ marginTop: -8 }}>
        Merchant API key'inle giriş yap. (cp_live_… ile başlar)
      </p>
      <form onSubmit={handleSubmit} aria-label="admin-login">
        <label htmlFor="cp-admin-apikey" className="muted" style={{ fontSize: 11 }}>
          API KEY
        </label>
        <input
          id="cp-admin-apikey"
          className="input"
          type="password"
          autoComplete="off"
          placeholder="cp_live_…"
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
          required
          style={{ marginTop: 4, marginBottom: 12 }}
        />
        <button
          type="submit"
          className="btn"
          disabled={submitting || apiKey.length === 0}
          style={{ width: '100%' }}
        >
          {submitting ? 'Bağlanıyor…' : 'Giriş'}
        </button>
        {error ? <div className="error" style={{ marginTop: 12 }}>{error}</div> : null}
      </form>
    </div>
  );
}
